export const toastMixin = {
  methods: {
    sendSuccessToast (message) {
      this.$message({
        message: message,
        type: 'success',
        customClass: 'toast toast--bg-success',
        iconClass: 'el-message__icon el-icon-success toast__icon'
      })
    },
    sendErrorToast (message) {
      this.$message({
        message: message,
        type: 'error',
        customClass: 'toast toast--bg-error',
        iconClass: 'el-message__icon el-icon-error toast__icon'
      })
    },
    sendWarningToast (message) {
      this.$message({
        message: message,
        type: 'warning',
        customClass: 'toast toast--bg-warning',
        iconClass: 'el-message__icon el-icon-warning toast__icon'
      })
    },
    sendInfoToast (message) {
      this.$message({
        message: message,
        type: 'info',
        customClass: 'toast toast--bg-info',
        iconClass: 'el-message__icon el-icon-info toast__icon'
      })
    }
  }
}
